import React from 'react';
import { FileText, Download, Filter, Calendar } from 'lucide-react';
import { Button } from '../components/ui/button';
import { LoadingOverlay } from '../components/ui/LoadingOverlay';
import { useLoading } from '../hooks/useLoading';
import { sleep } from '../utils/sleep';

const Reports = () => {
  const { isLoading, withLoading } = useLoading();

  const handleGenerateReport = async (type: string) => {
    await withLoading(async () => {
      // Simulate API call
      await sleep(3000);
      console.log(`Generating ${type} report...`);
    });
  };

  return (
    <div className="space-y-6 relative">
      {isLoading && <LoadingOverlay message="Generating report..." />}

      {/* Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <FileText className="h-8 w-8 text-blue-500" />
          <div>
            <h1 className="text-2xl font-bold text-white">Reports & Analytics</h1>
            <p className="text-sm text-gray-400">Generate and view security reports</p>
          </div>
        </div>
        <div className="flex items-center space-x-3">
          <Button variant="outline">
            <Calendar className="h-4 w-4 mr-2" />
            Schedule Report
          </Button>
          <Button disabled>
            <Download className="h-4 w-4 mr-2" />
            Export Report
          </Button>
        </div>
      </div>

      {/* Report Types */}
      <div className="grid grid-cols-3 gap-6">
        {['Executive Summary', 'Technical Report', 'Compliance Report'].map((type) => (
          <div key={type} className="bg-[#0F1629] rounded-xl p-6 border border-gray-800/50">
            <h3 className="text-lg font-semibold text-white mb-4">{type}</h3>
            <p className="text-sm text-gray-400 mb-4">
              Comprehensive overview of your security posture and findings.
            </p>
            <Button 
              variant="outline" 
              className="w-full"
              onClick={() => handleGenerateReport(type)}
            >
              Generate Report
            </Button>
          </div>
        ))}
      </div>

      {/* Recent Reports */}
      <div className="bg-[#0F1629] rounded-xl p-6 border border-gray-800/50">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-lg font-semibold text-white">Recent Reports</h2>
          <div className="flex items-center space-x-3">
            <Button variant="outline" size="sm" disabled>
              <Filter className="h-4 w-4 mr-2" />
              Filter
            </Button>
          </div>
        </div>

        <div className="space-y-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-center justify-between p-4 bg-gray-800/30 rounded-lg">
              <div className="flex items-center space-x-4">
                <FileText className="h-5 w-5 text-gray-400" />
                <div>
                  <div className="text-sm font-medium text-white">Monthly Security Report</div>
                  <div className="text-xs text-gray-400 mt-1">Generated on Feb 28, 2024</div>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Button variant="outline" size="sm" disabled>View</Button>
                <Button variant="outline" size="sm" disabled>
                  <Download className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Reports;